export default __webpack_public_path__ + "static/media/cerrarsesion_blanco.2664bd91.svg";